import "./polyfills/map-get-or-insert-computed"

import * as React from "react"

import { createRoot } from "react-dom/client"

import "@fontsource-variable/dm-sans"
import "./index.css"
import "./customer/custom.css"
import "./languageConfig"
import { installChunkReloadHandler } from "@/lib/chunk-reload"
import { registerGlobalErrorTelemetry } from "@/lib/telemetry"

import { App } from "./app"
import customerConfig from "./customer/config.json"
import { getInjectedAppName } from "./lib/runtime-branding"
import { ImageCacheService } from "./services/image-cache-service"

const config = customerConfig["config"]
// Precedence: server-injected branding (already reflected in the shipped
// <title>, see services/branding_injection.py) > build-time config.json >
// hardcoded default. Without this check, this line would unconditionally
// stomp the server's branded title back to the generic build-time default
// on every load — exactly the FOUC-equivalent bug #2741 exists to close,
// just for the tab title instead of colors.
document.title = getInjectedAppName() ?? config.page_title

// Best-effort runtime-error telemetry: window.onerror + unhandledrejection.
// Idempotent and swallows its own failures.
registerGlobalErrorTelemetry()

// Recover from stale content-hashed chunks after a deploy: reload once when a
// dynamic import 404s (vite:preloadError) instead of throwing to the user.
installChunkReloadHandler()

// Clean up expired image cache entries on app load
ImageCacheService.cleanupExpired()

createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
